import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

/** Route guard: redirects to /login when `GET /dashboard/me` has no valid session. Courtesy-only -
 * every `/dashboard/...` and `/v1/...` route re-checks the session server-side regardless. */
export function RequireAuth() {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
